<div class="dropdown d-inline-block" ngbDropdown placement="bottom-right">
  <button
    ngbDropdownToggle
    class="btn btn-link dropdown-toggle text-secondary pr-0"
    type="button"
    id="dropdownMenuLink"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <span class="fi fi-{{ activeLang.flag }}"></span>
  </button>

  <div
    class="dropdown-menu text-right"
    aria-labelledby="dropdownMenuLink"
    ngbDropdownMenu
  >
    <a
      class="dropdown-item"
      href
      *ngFor="let lang of languages"
      (click)="onChangeLang(lang); (false)"
      [hidden]="lang.symbol === activeLang.symbol"
    >
      {{ lang.name | translate }}
      <span class="fi fi-{{ lang.flag }}"></span>
    </a>
  </div>
</div>
